import { useMutation } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { useCallback } from 'react';
import { gqlClient } from '@/lib';
import type { QueryError } from '@/utils/errors';
import type {
  RequestEmailVerificationMutation,
  RequestEmailVerificationMutationVariables,
} from './useRequestEmailVerification.generated';

const query = gql`
  mutation RequestEmailVerification {
    requestEmailVerification
  }
`;

export const useRequestEmailVerification = () => {
  const { mutate, isPending } = useMutation<
    RequestEmailVerificationMutation,
    QueryError,
    RequestEmailVerificationMutationVariables
  >({
    mutationFn: (variables) =>
      gqlClient.request<
        RequestEmailVerificationMutation,
        RequestEmailVerificationMutationVariables
      >(query, variables),
  });

  const requestEmailVerification = useCallback(() => {
    mutate({});
  }, [mutate]);

  return { requestEmailVerification, isPending };
};
